"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var routes = {
  '/brands': {
    title: 'Brands',
    view: 'Brands',
    "public": true,
    locales: {
      az: '/az/brands',
      en: '/en/brands',
      ru: '/ru/brands'
    }
  },
  '/az/brands': {
    ref: '/brands',
    lang: 'az',
    title: 'Brendlər'
  },
  '/en/brands': {
    ref: '/brands',
    lang: 'en',
    title: 'Brands'
  },
  '/ru/brands': {
    ref: '/brands',
    lang: 'ru',
    title: 'Бренды'
  }
};
var _default = exports["default"] = routes;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJyb3V0ZXMiLCJ0aXRsZSIsInZpZXciLCJsb2NhbGVzIiwiYXoiLCJlbiIsInJ1IiwicmVmIiwibGFuZyIsIl9kZWZhdWx0IiwiZXhwb3J0cyJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL2xpYnJhcnkvc3JjL2NsaWVudC9tb2R1bGVzL0Vjb21tZXJjZS9CcmFuZC9CcmFuZFJvdXRlcy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCByb3V0ZXMgPSB7XHJcbiAgICAnL2JyYW5kcyc6IHtcclxuICAgICAgICB0aXRsZTogJ0JyYW5kcycsXHJcbiAgICAgICAgdmlldzogJ0JyYW5kcycsXHJcbiAgICAgICAgcHVibGljOiB0cnVlLFxyXG4gICAgICAgIGxvY2FsZXM6IHtcclxuICAgICAgICAgICAgYXo6ICcvYXovYnJhbmRzJyxcclxuICAgICAgICAgICAgZW46ICcvZW4vYnJhbmRzJyxcclxuICAgICAgICAgICAgcnU6ICcvcnUvYnJhbmRzJyxcclxuICAgICAgICB9XHJcbiAgICB9LFxyXG4gICAgJy9hei9icmFuZHMnOiB7cmVmOiAnL2JyYW5kcycsIGxhbmc6ICdheicsIHRpdGxlOiAnQnJlbmRsyZlyJ30sXHJcbiAgICAnL2VuL2JyYW5kcyc6IHtyZWY6ICcvYnJhbmRzJywgbGFuZzogJ2VuJywgdGl0bGU6ICdCcmFuZHMnfSxcclxuICAgICcvcnUvYnJhbmRzJzoge3JlZjogJy9icmFuZHMnLCBsYW5nOiAncnUnLCB0aXRsZTogJ9CR0YDQtdC90LTRiyd9LFxyXG59XHJcblxyXG5leHBvcnQgZGVmYXVsdCByb3V0ZXM7XHJcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsSUFBTUEsTUFBTSxHQUFHO0VBQ1gsU0FBUyxFQUFFO0lBQ1BDLEtBQUssRUFBRSxRQUFRO0lBQ2ZDLElBQUksRUFBRSxRQUFRO0lBQ2QsVUFBUSxJQUFJO0lBQ1pDLE9BQU8sRUFBRTtNQUNMQyxFQUFFLEVBQUUsWUFBWTtNQUNoQkMsRUFBRSxFQUFFLFlBQVk7TUFDaEJDLEVBQUUsRUFBRTtJQUNSO0VBQ0osQ0FBQztFQUNELFlBQVksRUFBRTtJQUFDQyxHQUFHLEVBQUUsU0FBUztJQUFFQyxJQUFJLEVBQUUsSUFBSTtJQUFFUCxLQUFLLEVBQUU7RUFBVSxDQUFDO0VBQzdELFlBQVksRUFBRTtJQUFDTSxHQUFHLEVBQUUsU0FBUztJQUFFQyxJQUFJLEVBQUUsSUFBSTtJQUFFUCxLQUFLLEVBQUU7RUFBUSxDQUFDO0VBQzNELFlBQVksRUFBRTtJQUFDTSxHQUFHLEVBQUUsU0FBUztJQUFFQyxJQUFJLEVBQUUsSUFBSTtJQUFFUCxLQUFLLEVBQUU7RUFBUTtBQUM5RCxDQUFDO0FBQUEsSUFBQVEsUUFBQSxHQUFBQyxPQUFBLGNBRWNWLE1BQU0ifQ==